import { render } from "./LawsView.vue?vue&type=template&id=6dad72fe"
import script from "./LawsView.vue?vue&type=script&lang=js"
export * from "./LawsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__